import InviraUserUpdate from './InviraUserUpdate.vue'
export {InviraUserUpdate}
export default InviraUserUpdate

